module.exports = __webpack_public_path__ + "img/In-House Finance Professional.af587bf7.svg";